<template>
  <v-chip color="grey-300"
          :closable="true"
          size="small"
          truncate-length="24"
          variant="flat"
          @click:close="removeCategory"
  >
    <div :style="{'max-width': '300px'}" class="text-truncated">
      {{category.name}}
    </div>
  </v-chip>
</template>

<script>
export default {
  name: 'QuestionAnswerCategoryChip',
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  methods: {
    removeCategory () {
      this.$emit('remove-category')
    },
  },
}
</script>
